
import { defineComponent, onMounted, ref, inject, computed } from "vue";
import { useStore } from "vuex";
import GlobalService from "@/core/services/GlobalService";
import { errManager, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
//componentes
import AddEditFunction from "./modals/AddEdit.vue";

export default defineComponent({
    name: "funciones",
    components: { AddEditFunction },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const loader = ref(false);
        const altura = screen.height - 365;
        const filter = ref({
            search: '',
            category: '',
            type: '',
            limit: '',
            page: '',
        });
        const rowItem = ref<any>(null);
        const listFunctions = ref<any>([]);
        
        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0)
        const AddEditFunctionRef = ref<any>(null);
        
        const getCompany = computed(() => {
            return store.getters.currentUser?.company
        });
        
        const getData = async() => {
            loader.value = true;
            try {
                const queryParams = new URLSearchParams({
                    ...filter.value,
                    limit: String(pageSize.value),
                    page: String(currentPage.value)
                });
                const res = await GlobalService.get('api', `functions?${queryParams}`);
                listFunctions.value = res.data?.data;
                totalItems.value = res.data?.total;

            } catch (error) {
                errManager(error);
            } finally {
                loader.value = false;
            }
        }

        const handleSizeChange = (val: number) => {
            pageSize.value = val
            getData();
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const openModal = (data: any) => {
            if(AddEditFunctionRef.value){
                rowItem.value = data
                AddEditFunctionRef.value.openModal();
            }
        }

        const onDelete = (row: any) => {
            Swal.fire({
              title: t('deleteRecord'),
                html: t('deleteText', {text: row.name}),
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: t('cancel'),
                confirmButtonText: t('delete'),
                reverseButtons: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: "#d33",
                preConfirm: () => {
                    return GlobalService.delete('functions', `${row.idfunction}/delete`)
                    .then((res) => {
                        return res.data;
                    }).catch(({ response })=>{
                        Swal.showValidationMessage(
                            `Request failed: ${response}`
                        )
                    });
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification({title: result.value.title, message: result.value.message, status: result.value.status});
                    result.value.status === 'success' && getData();
                }
            })
        }

        const onResponseAddEditFunction = (data:any) => {
            if(!data) return;
            if(data.status == 'success') getData();
        }

        onMounted(async () => {
            getData();
        })

        return {
            t,
            loader,
            altura,
            filter,
            listFunctions,
            getCompany,
            pageSize,
            currentPage,
            totalItems,
            moment,
            rowItem,
            AddEditFunctionRef,
            //events
            getData,
            onDelete,
            handleSizeChange,
            handleCurrentChange,
            openModal,
            onResponseAddEditFunction
        }
    },
})
